import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { getallapplicant, reset } from "../../features/Applicant/applicantSlice";
import NewApplicantTable from "./ApplicantTableComponent/NewApplicantTable";
import swal from "sweetalert";

const NewApplicants = () => {
  const [resetID, setResetID] = useState(false)
  const dispatch = useAppDispatch();
  const {
    EvalvationisSuccess,
    UpdateScreeningStatusisSuccess,
    sendOfferisSuccess,
    applicationInterviewisSuccess,
    updateApplicationInterviewStatusisSuccess,
    sendEmailisSuccess,
    shareApplicationisSuccess,
    ScreeningisSuccess,
    applicationassignedisSuccess,
    scheduleApplicantisSuccess,
    updateInterviewStatusisSuccess,
    UpdateOfferisSuccess,
    sendForHireisSuccess,
    EditapplicantionisSuccess,
    sendForTranningisSuccess,
    updateTranningisSuccess,
    data,
    isError,
    isLoading,
    message,
  } = useAppSelector((state: { applicant: any }) => state.applicant);

  useEffect(() => {
    const input = { applicationStatus: "APPLIED" };
    if (
      EvalvationisSuccess ||
      UpdateScreeningStatusisSuccess ||
      sendOfferisSuccess ||
      applicationInterviewisSuccess ||
      updateApplicationInterviewStatusisSuccess ||
      sendEmailisSuccess ||
      shareApplicationisSuccess ||
      ScreeningisSuccess ||
      applicationassignedisSuccess ||
      scheduleApplicantisSuccess ||
      updateInterviewStatusisSuccess ||
      UpdateOfferisSuccess ||
      sendForTranningisSuccess ||
      sendForHireisSuccess || EditapplicantionisSuccess || updateTranningisSuccess || resetID
    ) {
      // @ts-ignore 
      dispatch(getallapplicant(input))

      setTimeout(() => {
        dispatch(reset());
      }, 2000);
    }
  }, [resetID, UpdateOfferisSuccess, EvalvationisSuccess, UpdateScreeningStatusisSuccess, sendOfferisSuccess, applicationInterviewisSuccess, updateApplicationInterviewStatusisSuccess, sendEmailisSuccess, shareApplicationisSuccess, ScreeningisSuccess, applicationassignedisSuccess, scheduleApplicantisSuccess, updateInterviewStatusisSuccess, sendForHireisSuccess, EditapplicantionisSuccess, dispatch, sendForTranningisSuccess, updateTranningisSuccess]);



  useEffect(() => {
    const input = { applicationStatus: "APPLIED" };
    // @ts-ignore 
    dispatch(getallapplicant(input))

  }, [ScreeningisSuccess, dispatch]);




  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])




  return (
    <div>
      <NewApplicantTable
        pageHeader={"New Applicants"}
        data={data}
        isLoading={isLoading}
        message={message}
        isError={isError}
        setResetID={setResetID}
        headerTitles={[
          "",
          "Edit",
          "Title",
          "Applicant Name",
          "Gender",
          "Date Of Birth",
          "Email ",
          "Job Profile",
          "View ID",
          "Applied On",
          "Phone Number",
          "Recruiter",
          "Total Work Experience",
          "Relevant Work Experience",
          "Current Salary",
          "Expected Salary",
          "Edit"
        ]} />
    </div>
  );
};

export default NewApplicants;
